<div class="animated fadeInRight main-view">
    <h2>
        <div class="vertical-center">
            <mat-icon>receipt</mat-icon>
            &nbsp;{{auftrag.Id ? ('Neuauftrag.Edit'| translate ) : ('Neuauftrag.subtitle' | translate)}}
        </div>
    </h2>

    <mat-divider></mat-divider>

    <div class="row no-padding">
        <div class="col-md-6 col-left">
            <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                <mat-label>{{'Neuauftrag.Forderung.Forderungsart.Titel' | translate}}</mat-label>
                <mat-select [(ngModel)]="auftrag.Forderungsart" (selectionChange)="changeForderungsArt()"
                            [formControl]="ctrForderungsart" required placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                    <mat-option [value]="3">{{'Neuauftrag.Forderung.Forderungsart.KVG' | translate}}</mat-option>
                    <mat-option [value]="1">{{'Neuauftrag.Forderung.Forderungsart.UVG' | translate}}</mat-option>
                    <mat-option [value]="2">{{'Neuauftrag.Forderung.Forderungsart.VS' | translate}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        @if (this.oroservice?.kundeninfo?.Standorte?.length > 1) {
        <div class="col-md-6 col-right">
            <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                <mat-label>{{'Standort' | translate}}</mat-label>
                <mat-select [(ngModel)]="this.auftrag.GewaehlterStandort" required
                            placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                    @for (standort of this.oroservice.kundeninfo.Standorte; track standort) {
                    <mat-option [value]="standort.Id">
                        {{standort.Name}}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        }
    </div>

    <!-- Schuldner -->
    <div class="vertical-center" style="margin: 8px;">
        <mat-icon color="primary">person</mat-icon>&nbsp;<b>{{'Rechnungsempfaenger' | translate}}</b>
    </div>

    <div class="outline-blue" style="margin-bottom: 19px;">
        <!-- Juristische Person -->
        @if (auftrag.Personenart == 2) {
        <div class="row no-padding">
            <div class="col-md-6 col-left">
                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Personenart.auswählen' | translate}}</mat-label>
                    <mat-select [(ngModel)]="auftrag.Personenart" [formControl]="ctrPersonenart" required
                                placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                        <mat-option [value]="1">
                            {{'Neuauftrag.Rechnungsempfaenger.Personenart.Natürliche' | translate}}
                        </mat-option>
                        <mat-option [value]="2">
                            {{'Neuauftrag.Rechnungsempfaenger.Personenart.Juristische' | translate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-md-6 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Stammdaten.Rechtsform' | translate}}</mat-label>
                    <mat-select [(ngModel)]="auftrag.Rechtsform" required
                                placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                        @for (rechtsform of this.oroservice.kundeninfo.Rechtsformen; track rechtsform) {
                        <mat-option [value]="rechtsform.Id" [hidden]="rechtsform.Id == 0">
                            {{rechtsform.Name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        }
        @if (auftrag.Personenart == 2) {
        <div class="row no-padding">
            <div class="col-md-6 col-left">
                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Stammdaten.Firmenname' | translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.Name" required
                           placeholder="{{'RequiredPlaceholder' | translate}}" [formControl]="ctrName" type="text"
                           autocomplete='off' minlength="2">
                </mat-form-field>
            </div>
            <div class="col-md-6 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Anrede.auswählen' | translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.Briefanrede" type="text">
                </mat-form-field>
            </div>
        </div>
        }

        <!-- Natürliche Person -->
        @if (auftrag.Personenart != 2) {
        <div class="row no-padding">
            <div class="col-md-4 col-left">
                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Personenart.auswählen' | translate}}</mat-label>
                    <mat-select [(ngModel)]="auftrag.Personenart" [formControl]="ctrPersonenart" required
                                placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                        <mat-option [value]="1">
                            {{'Neuauftrag.Rechnungsempfaenger.Personenart.Natürliche' | translate}}
                        </mat-option>
                        <mat-option [value]="2">
                            {{'Neuauftrag.Rechnungsempfaenger.Personenart.Juristische' | translate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-md-4 col-middle">
                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Anrede.auswählen' | translate}}</mat-label>
                    <mat-select [(ngModel)]="auftrag.Anrede" [formControl]="ctrAnrede" required
                                placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                        <mat-option [value]="1">
                            {{'Neuauftrag.Rechnungsempfaenger.Anrede.Herr' | translate}}
                        </mat-option>
                        <mat-option [value]="2">
                            {{'Neuauftrag.Rechnungsempfaenger.Anrede.Frau' | translate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-md-4 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
                    <mat-select [(ngModel)]="auftrag.Titel">
                        @for (titel of this.oroservice.kundeninfo.Titel; track titel) {
                        <mat-option [value]="titel.Id">
                            {{titel.Name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        }

        @if (auftrag.Personenart != 2 && auftrag.Titel == 20) {
        <div class="row no-padding">
            <div class="col-md-4 col-left">
            </div>
            <div class="col-md-4 col-middle">
            </div>
            <div class="col-md-4 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.TitelSonstige" type="text">
                </mat-form-field>
            </div>
        </div>
        }


        @if (auftrag.Personenart != 2 || auftrag.Rechtsform == 1 || auftrag.Rechtsform == 2) {
        <div class="row no-padding">
            <div class="col-md-4 col-left">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Vorname' | translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.Vorname" required
                           placeholder="{{'RequiredPlaceholder' | translate}}" [formControl]="ctrVorname" type="text"
                           autocomplete='off' minlength="2">
                </mat-form-field>
            </div>
            <div class="col-md-4 col-middle">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Name' | translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.Name" required
                           placeholder="{{'RequiredPlaceholder' | translate}}" [formControl]="ctrName" type="text"
                           autocomplete='off' minlength="2">
                </mat-form-field>
            </div>
            <div class="col-md-4 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always"
                                [class.mat-form-field-invalid]="hasGeburtsdatumInvalidError || hasGeburtsdatumError">
                    <mat-label>{{'Geburtsdatum' | translate}}</mat-label>
                    <input matInput style="margin: 0px"
                           [ngModel]="geburtsdatumText"
                           (ngModelChange)="checkGeburtsdatumError($event); auftrag.Geburtsdatum=this.oroservice.ChangeDate($event);"
                           autocomplete="off">
                    <input type="hidden" [matDatepicker]="pickerVon" [(ngModel)]="auftrag.Geburtsdatum"
                           (ngModelChange)="checkGeburtsdatumError($event)">
                    <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
                    <mat-datepicker #pickerVon></mat-datepicker>

                </mat-form-field>
            </div>
        </div>
        }

        @if (this.hasGeburtsdatumInvalidError || this.hasGeburtsdatumError || (auftrag.Personenart != 2 && this.isMinderjaehrig())) {
        <mat-error>
            @if (this.hasGeburtsdatumError) {
            <div class="row no-padding">
                {{ 'Neuauftrag.Rechnungsempfaenger.GeburtsdatumZukunft' | translate }}
            </div>
            } @else if (auftrag.Personenart != 2 && this.isMinderjaehrig()) {
            <div class="row no-padding">
                {{ 'Neuauftrag.Rechnungsempfaenger.minderjaehrig' | translate }}
            </div>
            } @else {
            <div class="row no-padding">
                "{{ 'DatumUngueltig' | translate }}"
            </div>
            }
        </mat-error>
        }

        <div class="row no-padding">
            <div class="col-md-8 col-left">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Anschrift1' | translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.Anschrift1" [formControl]="ctrAnschrift" type="text"
                           autocomplete="off" required placeholder="{{'RequiredPlaceholder' | translate}}">
                </mat-form-field>
            </div>
            <div class="col-md-4 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Hausnummer' | translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.Hausnummer" [formControl]="ctrHausnummer" type="text"
                           autocomplete="off" required placeholder="{{'RequiredPlaceholder' | translate}}">
                </mat-form-field>
            </div>
        </div>

        <div class="row no-padding">
            <div class="col-md-4 col-left">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Postfach' | translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.Postfach" [formControl]="ctrPostfach" type="text"
                           autocomplete='off'>
                </mat-form-field>
            </div>

            <div class="col-md-8 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Adresszusatz' | translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.Anschrift2" [formControl]="ctrAdresszusatz" type="text"
                           autocomplete='off'>
                </mat-form-field>
            </div>
        </div>

        <div class="row no-padding">
            <div class="col-md-4 col-left">
                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Land' | translate}}</mat-label>
                    <mat-select [(ngModel)]="auftrag.Land" [formControl]="ctrLand" required
                                placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                        <mat-option [value]="0">{{'Neuauftrag.Forderung.Land.CH' | translate}}</mat-option>
                        <mat-option [value]="1">{{'Neuauftrag.Forderung.Land.FL' | translate}}</mat-option>
                        <mat-option [value]="2">{{'Neuauftrag.Forderung.Land.DE' | translate}}</mat-option>
                        <mat-option [value]="3">{{'Neuauftrag.Forderung.Land.FR' | translate}}</mat-option>
                        <mat-option [value]="4">{{'Neuauftrag.Forderung.Land.AUT' | translate}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-md-4 col-middle">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'PLZ' | translate}}</mat-label>
                    <input matInput type="text" (ngModelChange)="checkPlz($event)" [(ngModel)]="auftrag.Plz" [formControl]="ctrPLZ"
                           required placeholder="{{'RequiredPlaceholder' | translate}}">
                </mat-form-field>
            </div>
            @if (auftrag.Land == 0) {
            <div class="col-md-4 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Ort' | translate}}</mat-label>
                    <mat-select [(ngModel)]="auftrag.Ort" [formControl]="ctrOrt" required
                                placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                        @for (plzinfo of this.plzinfolisteFilter; track plzinfo) {
                        <mat-option [value]="plzinfo.Ort">{{plzinfo.Ort}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            }
            @if (auftrag.Land != 0) {
            <div class="col-md-4 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Ort' | translate}}</mat-label>
                    <input matInput type="text" [(ngModel)]="auftrag.Ort" [formControl]="ctrOrt" required
                           placeholder="{{'RequiredPlaceholder' | translate}}">
                </mat-form-field>
            </div>
            }
        </div>

        <!-- 0 = CH, 1 = LI -->
        @if (auftrag.Land && auftrag.Land > 1) {
        <mat-info>{{'Neuauftrag.Auslandsinkassoinfo' | translate}}</mat-info>
        }
    </div>

    <!-- Patient -->
    @if (this.oroservice.kundeninfo.PatientAbfrage && this.oroservice.kundeninfo.Berufsgruppe != 3 && this.auftrag.Forderungsart != 2) {
    <div>
        @if (auftrag.IstPatient) {
        <div class="row no-padding">
            <mat-checkbox color="primary" [(ngModel)]="auftrag.IstPatient">
                {{'Neuauftrag.Patient.checkbox' | translate}}
            </mat-checkbox>
        </div>
        }
        @if (!auftrag.IstPatient) {
        <div>
            <div class="vertical-center" style="margin: 8px;">
                <mat-icon color="primary">person_outline</mat-icon>
                &nbsp;<b>{{'Neuauftrag.Patient.title' | translate}}</b>
            </div>
            <div class="outline-blue" style="margin-bottom: 19px;">
                <div class="row no-padding">
                    <mat-checkbox color="primary" [(ngModel)]="auftrag.IstPatient">
                        {{'Neuauftrag.Patient.checkbox' | translate}}
                    </mat-checkbox>
                </div>
                <div class="row no-padding">
                    <div class="col-md-4 col-left">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                            <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Anrede.auswählen' | translate}}</mat-label>
                            <mat-select [(ngModel)]="auftrag.AnredePatient" [formControl]="ctrAnredePat" required
                                        placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                                <mat-option [value]="1">
                                    {{'Neuauftrag.Rechnungsempfaenger.Anrede.Herr' | translate}}
                                </mat-option>
                                <mat-option [value]="2">
                                    {{'Neuauftrag.Rechnungsempfaenger.Anrede.Frau' | translate}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4 col-middle">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'Vorname' | translate}}</mat-label>
                            <input matInput [(ngModel)]="auftrag.VornamePat" [formControl]="ctrVornamePat" required
                                   placeholder="{{'RequiredPlaceholder' | translate}}" type="text" minlength="2">
                        </mat-form-field>
                    </div>
                    <div class="col-md-4 col-right">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'Name' | translate}}</mat-label>
                            <input matInput [(ngModel)]="auftrag.NamePat" [formControl]="ctrNamePat" required
                                   placeholder="{{'RequiredPlaceholder' | translate}}" type="text" minlength="2">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row no-padding">
                    <div class="col-md-6 col-left">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always"
                                        [class.mat-form-field-invalid]="hasGeburtsdatumPatInvalidError || hasGeburtsdatumPatError">
                            <mat-label>{{'Geburtsdatum' | translate}}</mat-label>
                            <input matInput style="margin: 0px"
                                   [ngModel]="geburtsdatumPatText"
                                   (ngModelChange)="checkGeburtsdatumPatError($event); auftrag.GeburtsdatumPat=this.oroservice.ChangeDate($event);"
                                   autocomplete="off">
                            <input type="hidden" [matDatepicker]="pickerVon" [(ngModel)]="auftrag.GeburtsdatumPat"
                                   (ngModelChange)="checkGeburtsdatumPatError($event)">
                            <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
                            <mat-datepicker #pickerVon></mat-datepicker>

                        </mat-form-field>
                    </div>

                    <div class="col-md-6 col-right">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                            <mat-label>{{'Neuauftrag.Patient.Beziehung' | translate}}</mat-label>
                            <mat-select [(ngModel)]="this.auftrag.BeziehungPatient" [formControl]="ctrBeziehungPat"
                                        required placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                                @for (beziehung of this.oroservice.kundeninfo.BeziehungenPatient; track beziehung) {
                                <mat-option required [value]="beziehung.Id">
                                    {{beziehung.Name}}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                @if (this.hasGeburtsdatumPatInvalidError || this.hasGeburtsdatumPatError) {
                <mat-error>
                    @if (this.hasGeburtsdatumPatInvalidError) {
                    <div class="row no-padding">
                        {{ 'DatumUngueltig' | translate }}
                    </div>
                    } @else {
                    <div class="row no-padding">
                        {{ 'Neuauftrag.Rechnungsempfaenger.GeburtsdatumZukunft' | translate }}
                    </div>
                    }
                </mat-error>
                }

                <div class="row no-padding">
                    <div class="col-md-8 col-left">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'Anschrift1' | translate}}</mat-label>
                            <input matInput [(ngModel)]="auftrag.Anschrift1Pat" [formControl]="ctrAnschriftPat"
                                   type="text" autocomplete='off'>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4 col-right">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'Hausnummer' | translate}}</mat-label>
                            <input matInput [(ngModel)]="auftrag.HausnummerPat" [formControl]="ctrHausnummerPat"
                                   type="text" autocomplete='off'>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row no-padding">
                    <div class="col-md-4 col-left">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'Postfach' | translate}}</mat-label>
                            <input matInput [(ngModel)]="auftrag.PostfachPat" [formControl]="ctrPostfachPat" type="text"
                                   autocomplete='off'>
                        </mat-form-field>
                    </div>
                    <div class="col-md-8 col-right">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'Adresszusatz' | translate}}</mat-label>
                            <input matInput [(ngModel)]="auftrag.Anschrift2Pat" [formControl]="ctrAdresszusatzPat"
                                   type="text" autocomplete='off'>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row no-padding">
                    <div class="col-md-4 col-left">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                            <mat-label>{{'Land' | translate}}</mat-label>
                            <mat-select [(ngModel)]="auftrag.LandPat" [formControl]="ctrLandPat" required
                                        placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                                <mat-option [value]="0">{{'Neuauftrag.Forderung.Land.CH' | translate}}</mat-option>
                                <mat-option [value]="1">{{'Neuauftrag.Forderung.Land.FL' | translate}}</mat-option>
                                <mat-option [value]="2">{{'Neuauftrag.Forderung.Land.DE' | translate}}</mat-option>
                                <mat-option [value]="3">{{'Neuauftrag.Forderung.Land.FR' | translate}}</mat-option>
                                <mat-option [value]="4">{{'Neuauftrag.Forderung.Land.AUT' | translate}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4 col-middle">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'PLZ' | translate}}</mat-label>
                            <input matInput type="text" (ngModelChange)="checkPlzPat($event)" [(ngModel)]="auftrag.PlzPat"
                                   [formControl]="ctrPLZPat" required placeholder="{{'RequiredPlaceholder' | translate}}">
                        </mat-form-field>
                    </div>
                    @if (auftrag.LandPat == 0) {
                    <div class="col-md-4 col-right">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                            <mat-label>{{'Ort' | translate}}</mat-label>
                            <mat-select [(ngModel)]="auftrag.OrtPat" [formControl]="ctrOrtPat" required
                                        placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                                @for (plzinfo of this.plzinfolisteFilterPat; track plzinfo) {
                                <mat-option [value]="plzinfo.Ort">{{plzinfo.Ort}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    }
                    @if (auftrag.LandPat != 0) {
                    <div class="col-md-4 col-right">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                            <mat-label>{{'Ort' | translate}}</mat-label>
                            <input matInput type="text" [(ngModel)]="auftrag.OrtPat" [formControl]="ctrOrtPat" required
                                   placeholder="{{'RequiredPlaceholder' | translate}}">
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
        @if (auftrag.Land && auftrag.Land > 1) {
        <mat-info>{{'Neuauftrag.Auslandsinkassoinfo' | translate}}</mat-info>
        }
    </div>
    }

    <!-- Behandler -->
    @if (this.oroservice.kundeninfo.BehandlerAbfrage && this.auftrag.Forderungsart != 2 && this.oroservice.kundeninfo.Behandler.length > 0) {
    <div>
        <div class="vertical-center" style="margin: 8px;">
            <mat-icon color="primary">medical_services</mat-icon>&nbsp;<b>{{'Neuauftrag.Behandler' | translate}}</b>
        </div>
        <div class="outline-blue" style="margin-bottom: 19px;">
            <div class="row no-padding">
                <mat-form-field appearance="fill" class="input-field no-padding" style="width:100%;"
                                floatLabel="always">
                    <mat-label>{{'BehandelndeArzt' | translate}}</mat-label>
                    <mat-select [(ngModel)]="this.auftrag.Behandler" [compareWith]="compareBehandler">
                        <mat-option [value]="{ Id: 0 }">
                            {{'Neuauftrag.BehandlerKein' | translate}}
                        </mat-option>
                        @for (behandler of this.oroservice.kundeninfo.Behandler; track behandler) {
                        <mat-option [value]="behandler">
                            {{behandler.Name}}, {{behandler.Vorname}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            @if (auftrag.Behandler && auftrag.Behandler.Id != 0) {
            <div class="row no-padding">
                <div class="col-md-4 col-left">
                    <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                        <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Anrede.auswählen' | translate}}</mat-label>
                        <!-- Anrede == 0 soll nur mit Migrationsdaten kommen -->
                        @if (auftrag.Behandler.Anrede == 0) {
                        <input matInput [value]="" readonly type="text">
                        }
                        @if (auftrag.Behandler.Anrede == 1) {
                        <input matInput
                               [value]="'Neuauftrag.Rechnungsempfaenger.Anrede.Herr' | translate" readonly type="text">
                        }
                        @if (auftrag.Behandler.Anrede == 2) {
                        <input matInput
                               [value]="'Neuauftrag.Rechnungsempfaenger.Anrede.Frau' | translate" readonly type="text">
                        }
                    </mat-form-field>
                </div>
                <div class="col-md-4 col-middle">
                    <mat-form-field appearance="fill" class="input-field" style="width:100%">
                        <mat-label>{{'Vorname' | translate}}</mat-label>
                        <input matInput [(ngModel)]="auftrag.Behandler.Vorname" readonly type="text">
                    </mat-form-field>
                </div>
                <div class="col-md-4 col-right">
                    <mat-form-field appearance="fill" class="input-field" style="width:100%">
                        <mat-label>{{'Name' | translate}}</mat-label>
                        <input matInput [(ngModel)]="auftrag.Behandler.Name" readonly type="text">
                    </mat-form-field>
                </div>
            </div>
            }
            @if (auftrag.Behandler && auftrag.Behandler.Id != 0 && this.auftrag.Behandler.Fachrichtung) {
            <div class="row no-padding">
                <mat-form-field appearance="fill" class="input-field no-padding" style="width:100%;">
                    <mat-label>{{'Fachrichtung' | translate}}</mat-label>
                    <input matInput [value]="getFachrichtung(this.auftrag.Behandler.Fachrichtung)" readonly type="text">
                </mat-form-field>
            </div>
            }
        </div>
    </div>
    }

    <!-- Forderung -->
    <div class="vertical-center" style="margin: 8px;">
        <mat-icon color="primary">receipt</mat-icon>&nbsp;<b>{{'Forderung' | translate}}</b>
    </div>
    <div class="outline-blue" style="margin-bottom: 19px;">
        @if (this.oroservice.kundeninfo.HasBehandlungsdatum && auftrag.Forderungsart != 2) {
        <div>
            <div class="row no-padding">
                <div class="col-md-4 col-left">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always"
                                    [class.mat-form-field-invalid]="hasBehandlungsdatumInvalidError || hasBehandlungsdatumError || hasBehandlungsdatumFutureError">
                        <mat-label>
                            {{'Dossier.Rechnungsnummer'| translate}}
                        </mat-label>
                        <input matInput [(ngModel)]="auftrag.Referenz" [formControl]="ctrReferenz" style="margin: 0px"
                               required placeholder="{{'RequiredPlaceholder' | translate}}" autocomplete='off'>
                    </mat-form-field>
                </div>
                <div class="col-md-4 col-middle">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always"
                                    [class.mat-form-field-invalid]="hasBehandlungsdatumInvalidError || hasBehandlungsdatumError || hasBehandlungsdatumFutureError">
                        <mat-label>
                            {{'Behandlungsdatum'| translate}}
                        </mat-label>
                        <input matInput style="margin: 0px" [ngModel]="behandlungsdatumText"
                               (ngModelChange)="checkBehandlungsdatumError($event); auftrag.Behandlungsdatum=this.oroservice.ChangeDate($event);"
                               autocomplete='off'>
                        <input type="hidden" [matDatepicker]="picker1" [(ngModel)]='auftrag.Behandlungsdatum'
                               (ngModelChange)="checkBehandlungsdatumError($event)">
                        <mat-datepicker-toggle matSuffix [for]="picker1" tabindex="-1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    @if (this.hasBehandlungsdatumInvalidError || this.hasBehandlungsdatumFutureError || this.hasBehandlungsdatumError) {
                    <mat-error>
                        @if (this.hasBehandlungsdatumError) {
                        {{ 'Neuauftrag.Forderung.ErrorBehandlungsdatum' | translate }}
                        } @else if (this.hasBehandlungsdatumFutureError) {
                        {{ 'Neuauftrag.Forderung.ErrorBehandlungsdatumFuture' | translate }}
                        } @else {
                        {{ 'DatumUngueltig' | translate }}
                        }
                    </mat-error>
                    }
                </div>
                <div class="col-md-4 col-right">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always"
                                    [class.mat-form-field-invalid]="hasRechnungsdatumInvalidError || hasRechnungsdatumError">
                        <mat-label>
                            {{'Rechnungsdatum'| translate}}
                        </mat-label>
                        <input matInput style="margin: 0px" [ngModel]="rechnungsdatumText"
                               [formControl]="ctrRechnungsdatum"
                               (ngModelChange)="checkRechnungsdatumError($event); auftrag.Rechnungsdatum=this.oroservice.ChangeDate($event);" required
                               placeholder="{{'RequiredPlaceholder' | translate}}" autocomplete='off'>
                        <input type="hidden" [matDatepicker]="picker2" [(ngModel)]='auftrag.Rechnungsdatum'
                               (ngModelChange)="checkRechnungsdatumError($event)">
                        <mat-datepicker-toggle matSuffix [for]="picker2" tabindex="-1"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                    @if (this.hasRechnungsdatumInvalidError || this.hasRechnungsdatumError) {
                    <mat-error>
                        @if (this.hasRechnungsdatumInvalidError) {
                        {{ 'DatumUngueltig' | translate }}
                        } @else {
                        {{ 'Neuauftrag.Forderung.ErrorRechnungsdatum' | translate }}
                        }
                    </mat-error>
                    }
                </div>
            </div>
        </div>
        }

        @if (!this.oroservice.kundeninfo.HasBehandlungsdatum || auftrag.Forderungsart == 2) {
        <div>
            <div class="row no-padding">
                <div class="col-md-6 col-left">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always"
                                    [class.mat-form-field-invalid]="hasRechnungsdatumError">
                        <mat-label>
                            {{
 auftrag.Forderungsart ==2 ? ('Neuauftrag.Forderung.Betreibungsnummer'| translate) :
                                                                ('Dossier.Rechnungsnummer'| translate)
                            }}
                        </mat-label>
                        <input matInput [(ngModel)]="auftrag.Referenz" style="margin: 0px" required
                               placeholder="{{'RequiredPlaceholder' | translate}}" autocomplete='off'
                               [formControl]="ctrReferenz">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-right">
                    <mat-form-field appearance="fill" style="width: 100%" floatLabel="always">
                        <mat-label>
                            {{
 auftrag.Forderungsart == 2 ? ('Verlustscheindatum'| translate) :
                                                                  ('Rechnungsdatum'|
                                                                  translate)
                            }}
                        </mat-label>
                        <input matInput style="margin: 0px" [ngModel]="rechnungsdatumText"
                               [formControl]="ctrRechnungsdatum"
                               (ngModelChange)="checkRechnungsdatumError($event); auftrag.Rechnungsdatum=this.oroservice.ChangeDate($event);" required
                               placeholder="{{'RequiredPlaceholder' | translate}}" autocomplete='off'>
                        <input type="hidden" [matDatepicker]="picker" [(ngModel)]='auftrag.Rechnungsdatum'
                               (ngModelChange)="checkRechnungsdatumError($event)">
                        <mat-datepicker-toggle matSuffix [for]="picker" tabindex="-1"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    @if (this.hasRechnungsdatumInvalidError || this.hasRechnungsdatumError) {
                    <mat-error>
                        @if (this.hasRechnungsdatumInvalidError) {
                        {{ 'DatumUngueltig' | translate }}
                        } @else {
                        {{ 'Neuauftrag.Forderung.ErrorVerlustscheindatum' | translate }}
                        }
                    </mat-error>
                    }
                </div>
            </div>
        </div>
        }

        <div class="row no-padding">
            <div class="col-md-4 col-left">
                <mat-form-field appearance="fill" class="custom-chf-prefix" style="width: 100%" floatLabel="always">
                    <mat-label>
                        {{
 auftrag.Forderungsart == 2 ? ('Neuauftrag.Verlustscheinbetrag' | translate) :
                                                                  ('Neuauftrag.Betrag' | translate)
                        }}
                    </mat-label>
                    <span matPrefix>CHF&nbsp;</span>
                    <input matInput [(ngModel)]="auftrag.Betrag" [formControl]="ctrBetrag" style="margin: 0px" required
                           placeholder="{{ 'RequiredPlaceholder' | translate }}" pattern="[(0-9)|']+([\.,][0-9]{1,2})?"
                           type="number" autocomplete="off" />
                </mat-form-field>
            </div>
            <div class="col-md-4 col-middle">
                <mat-form-field appearance="fill" class="custom-chf-prefix" style="width: 100%" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Teilzahlung'| translate}}</mat-label>
                    <input matInput [(ngModel)]="auftrag.Teilzahlung" style="margin: 0px"
                           (change)="checkTeilzahlungsError()" pattern="[(0-9)|']+([\.,][0-9]{1,2})?" type="number"
                           autocomplete='off'>
                    <span matPrefix>CHF&nbsp;</span>
                </mat-form-field>
            </div>
            <div class="col-md-4 col-right">
                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always"
                                [class.mat-form-field-invalid]="hasGeburtsdatumError">
                    <mat-label>{{'Forderungsgrund' | translate}}</mat-label>

                    @if (auftrag.Forderungsart == 2) {
                    <input matInput style="margin: 0px"
                           value="{{'Verlustschein' | translate}}" readonly>
                    }

                    @if (auftrag.Forderungsart != 2) {
                    <mat-select [(ngModel)]="auftrag.Forderungsgrund" required
                                placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                        @for (grund of this.oroservice.kundeninfo.Forderungsgruende; track grund) {
                        <mat-option [disabled]="grund.Id ==11" [value]="grund.Id">
                            {{grund.Name}}
                        </mat-option>
                        }
                    </mat-select>
                    }
                </mat-form-field>
            </div>
        </div>

        <div class="row no-padding">
            <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
              <mat-label>{{ getCustomerNumberLabelKey() | translate }}</mat-label>
              <input matInput [(ngModel)]="auftrag.ReKundennr" style="margin: 0px; width: 100%; display:block;" type="text" autocomplete='off'>
            </mat-form-field>
         </div>

          @if (this.hasTeilzahlungsError) {
          <div style="height: 36px">
            @if (this.hasTeilzahlungsError) {
            <mat-error>
              {{
'Neuauftrag.Forderung.ErrorTeilzahlungsbetrag' |
                                                                    translate
              }}
            </mat-error>
            }
          </div>
          }

          @if (this.hasMindestbetragError) {
          <div style="height: 36px">
            <mat-error>
              {{ 'Neuauftrag.Forderung.ErrorMindestbetrag' | translate }}
            </mat-error>
          </div>
          }
        </div>

    @if (auftrag.Forderungsart != 2 && (!auftrag.Land || auftrag.Land <= 1)) {
    <div class="row no-padding">
        <mat-checkbox color="primary" [(ngModel)]="auftrag.NurVorrechtlichesInkasso">
            {{'Neuauftrag.NurVorrechtlich' | translate}}
        </mat-checkbox>
    </div>
    }

    @if (auftrag.Forderungsart == 2) {
    <div class="row no-padding">
        <mat-checkbox color="primary" [(ngModel)]="auftrag.VerlustscheinDurchEncathvertreten"
                      matTooltip="{{'Neuauftrag.VerlustscheinEncathinfo' | translate}}" [matTooltipPosition]="'before'"
                      matTooltipClass="tooltip">
            {{'Neuauftrag.VerlustscheinEncath' | translate}}
        </mat-checkbox>
    </div>
    }

    @if (auftrag.Forderungsart == 2) {
    <div class="row no-padding">
        <mat-checkbox color="primary" [(ngModel)]="auftrag.VerlustscheinVerjaehrungUnterbrechen">
            {{'Neuauftrag.VerlustscheinVerjaehrungUnterbrechen' | translate}}
        </mat-checkbox>
    </div>
    }

    <div class="vertical-center" style="margin: 8px;">
        <mat-icon color="primary">description</mat-icon>&nbsp;<b>{{'Neuauftrag.Dokument' | translate}}</b>
    </div>

    <div class="outline-blue" style="margin-bottom: 19px;">
        <div style="margin: 8px">{{'Neuauftrag.InfoDokument' | translate}}</div>

        <div class="row no-padding">

            <div class="rmpm dropzone" style="width:260px" appDragDrop (files)="fileservice.filesDropped($event)">
                <div class="text-wrapper">
                    <div class="centered">
                        <mat-icon style="font-size: 64px; width:64px; height:64px; opacity: 0.2;">publish</mat-icon>
                        <BR>
                        {{'Drag' | translate}}
                    </div>
                </div>
            </div>

                                                                <div class="col">
                                                                  <button mat-button matSuffix (click)="fileMultiInput.click()">
                                                                    <mat-icon>attach_file</mat-icon> {{'Dateiauswaehlen' | translate}}
                                                                  </button>
                                                                  @if (fileservice.files.length > 3) {
                                                                    <button mat-button matSuffix
                                                                      (click)="fileservice.removeAllFiles()">
                                                                      <mat-icon>delete</mat-icon> {{'Alle löschen' | translate}}
                                                                    </button>
                                                                  }
                                                                  <input hidden (change)="fileservice.handleMultiFileInput($event.target.files)" #fileMultiInput
                                                                    type="file" accept=".pdf,.jpg,.jpeg" id="file" multiple>
                                                                    <div class="row no-padding">
                                                                        <mat-list class="attachment-list">
                                                                        @if (auftrag.DokumentId) {
                                                                          <mat-list-item class="attachment-list-item">
                                                                            @if (auftrag.DokumentName) {
                                                                              <div [ngStyle]="{'text-decoration': (auftrag.RemoveDokument > 0) ? 'line-through' : 'none'}"
                                                                              >{{auftrag.DokumentName}}</div>
                                                                            }
                                                                            @if (!auftrag.DokumentName) {
                                                                              <div>Anhang</div>
                                                                            }
                                                                            &nbsp;
                                                                            @if (auftrag.DokumentId) {
                                                                              <button mat-icon-button matSuffix
                                                                                (click)="this.oroservice.OpenDocument(auftrag.DokumentId, 'Auftrag')"
                                                                                style="margin:0px">
                                                                                <mat-icon>visibility</mat-icon>
                                                                              </button>
                                                                            }
                                                                            <button mat-icon-button color="accent" matSuffix (click)="toggleRemoveDokument()"
                                                                              style="margin:0px">
                                                                              <mat-icon>delete</mat-icon>
                                                                            </button>
                                                                          </mat-list-item>
                                                                        }
                                                                        @for (file of fileservice.files; track file) {
                                                                          <mat-list-item class="attachment-list-item">
                                                                            <mat-icon>picture_as_pdf</mat-icon>&nbsp;
                                                                            {{fileservice.getFileInfo(file)}}&nbsp;
                                                                            <button mat-icon-button color="accent" matSuffix (click)="fileservice.removeFile(file)"
                                                                              style="margin:0px">
                                                                              <mat-icon>delete</mat-icon>
                                                                            </button>
                                                                          </mat-list-item>
                                                                        }
                                                                      </mat-list>
                                                                    </div>
                                                                    @if (fileservice.isFileTooBig) {
                                                                      <div class="row no-padding">
                                                                        <mat-error>{{'ErrorSizeFormat' | translate}}</mat-error>
                                                                      </div>
                                                                    }
                                                                  </div>
                                                                </div>
                                                              </div>

    <div class="row no-padding">
        @if (!auftrag.Id) {
        <button mat-flat-button color="primary" class="button-dialog" (click)="create(true)"
                style="margin-top: 8px; margin-right: 12px; width:220px" [disabled]="!canSubmit()">
            {{'Neuauftrag.Next'| translate}}
        </button>
        }
        <button mat-flat-button color="primary" class="button-dialog" (click)="create()"
                style="margin-top: 8px; margin-right: 12px; width:220px" [disabled]="!canSubmit()">
            {{ auftrag.Id ? ('Neuauftrag.Bearbeiten'| translate) : ('Neuauftrag.Einreichen' | translate)}}
        </button>
        <button mat-flat-button color="primary" class="button-dialog" (click)="cancel()"
                style="margin-top: 8px; width:220px">
            {{'Startseite.Abbrechen'| translate}}
        </button>
    </div>
</div>
